  if($(".has-jQuery-pagination").length > 0){
	$.getScript( "https://cdnjs.cloudflare.com/ajax/libs/twbs-pagination/1.4.1/jquery.twbsPagination.min.js", function() {
		 jQueryPaginationPlugin();
	});
  }

  function jQueryPaginationPlugin(){
    var pager = $("#green-pagination");
    var totalPages = $('.no-of-pages').val();//pager.data('page-numbers');
    if(totalPages == 0)
	{
		return;
	}
	var startPage = 1;
    var hasPage = false;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++){
        if (hashes[i].indexOf("page") > -1){
          var hash = hashes[i].split('=');
          if (parseInt(hash[1]) <= totalPages) {
            startPage = parseInt(hash[1]);
          }
        }
    }

    pager.twbsPagination({
    totalPages: totalPages,
    startPage: startPage,

    // maximum visible pages
    visiblePages: 10,

    // // template for pagination links
    href: false,

    // variable name in href template for page number
    hrefVariable: '{{number}}',
    pageVariable:'{{page}}',

    // Text labels
    prev: '&lsaquo; <span class="hidden-xs hidden-sm">Previous</span>',
    next: '<span class="hidden-xs hidden-sm">Next</span> &rsaquo;',
    first:'',
    last:'',


    // // callback function
    onPageClick: function (event, page) {
     var queyString = [];
	  if (window.location.href.split('?').length == 1)
	  {
		  queyString.push("page="+page);
	  }
	  else if(window.location.href.split('?')[1].length == 0)
	  {
		  queyString.push("page="+page);
	  }
	  else
	  {
		  for (var i = 0; i < hashes.length; i++){
          if (hashes[i].includes("page")){
            var hash = hashes[i].split('=');
            queyString.push("page="+page);
            hasPage =  true;
          } else {
            queyString.push(hashes[i]);
          }
		  }
		  if (!hasPage){
			queyString.push("page="+page);
		  }
	  }

        location.assign('?'+queyString.join('&'));
    },
    //
    // // pagination Classes
    nextClass: 'nxt',
    prevClass: 'pre',
    pageClass: 'br-1',
    activeClass: 'green-pagination-active',
    initiateStartPageClick: false,
    });
  };
